import React, { useState, useEffect, forwardRef } from 'react';
import styles from './styles.module.scss';
import { useContext } from 'react';
import Loader from '../Loader';
import { AdminContext } from '../../context/AdminContext';
import Api from '../../api';
import Avatar from '../Avatar';

import SingleContact from '../SingleContact';
import Checkbox from '../CheckBox';
import AppFormInput from '../AppFormInput';
import { Form } from 'react-router-dom';
import AppFormTextArea from '../AppFormTextArea';
import EditImage from '../EditImage';
import blanckUser from '../../../../assets/imgs/blank-profile-picture.png';
import Button from '../Button';
import CookieFunction from '../../functions/cookieFunction';

const CraeteGroupModal = forwardRef((props, ref) => {
  const {
    setUserInfo,
    setGroupState,
    groupState,
    setOpenCreateGroup,
    userChannelId,
    activeUser,
    isMobile,
  } = useContext(AdminContext);
  const [contacts, setContacts] = useState([]);
  const [groupInfo, setGroupInfo] = useState({
    imageId: '',
    title: '',
    description: '',
    userIds: [],
    imageName: '',
  });

  const [showTitle, setShowTitle] = useState(true);
  const [showErrorTitle, setShowErrorTitle] = useState(false);
  const [showErrorUsers, setShowErrorUsers] = useState('');
  const [errorContent, setErrorContent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [serverError, setServerError] = useState('');

  useEffect(() => {
    if (groupState) {
      let newarray = [...groupState?.users];
      newarray = newarray.slice(1);
      newarray = newarray.map((item, index) => {
        return item?.channelUserId;
      });
      console.log('newarray', newarray);
      // setGroupInfo({
      //   imageName: groupState?.image?.name,
      //   imageId: groupState?.imageId,
      //   title: groupState?.title,
      //   description: groupState?.content,
      //   userIds: newarray?.length != 0 ? newarray : [],
      // });
      let channelId = CookieFunction('get', 'userAuthOchatt');
      let prevUsers = [...groupState?.users];
      prevUsers = prevUsers.slice(1);
      prevUsers = prevUsers.filter((x) => x.channelUser?.uuid != channelId);

      prevUsers = prevUsers.map((v, i) => {
        return {
          ...v,
          checked: v?.statusId == 0 ? false : true,
        };
      });
      console.log('prevU', prevUsers);
      searchFunction(newarray, prevUsers, groupState);
    } else {
      searchFunction([], []);
    }
  }, [groupState]);

  console.log('groupstate===', groupState, activeUser, contacts, groupInfo);

  const searchFunction = (ids, prevUsers, groupState) => {
    let combined = [...prevUsers];
    setLoading(true);
    Api.privateChatUsersChat()
      .then((res) => {
        let myContact = res?.data?.response
          .filter((x) => x.typeId != 2)
          .map((v, i) => {
            return {
              ...v?.users?.[0],
              checked:
                ids?.findIndex((x) => x == v?.channelUserId) == -1
                  ? false
                  : v?.statusId == 0
                  ? false
                  : true,
            };
          });

        let myContact2 = [...myContact];
        combined.map((item, m) => {
          myContact = myContact.filter(
            (x) => x?.channelUserId != item?.channelUserId
          );
        });
        // if (index != -1) {
        //   // myContact2 = myContact2.splice(index, 1);
        //   // myContact2.splice(index, 1);
        // }
        // combined.map((i,j)=>{
        //   if (x.channelUserId != item?.channelUserId)
        // })
        // myContact2 = myContact.filter(
        //   (x) => x.channelUserId != item?.channelUserId
        // );
        // });
        console.log('mycontact=', myContact, combined, myContact2);
        setContacts([...combined.concat(myContact)]);
        let dummyarray = [...combined.concat(myContact)];
        let preIds = dummyarray
          .filter((x) => x.checked == true)
          .map((i, j) => {
            return i?.channelUserId;
          });
        console.log('preid==', preIds, dummyarray);
        setGroupInfo({
          imageName: groupState ? groupState?.image?.name : '',
          imageId: groupState ? groupState?.imageId : '',
          title: groupState ? groupState?.title : '',
          description: groupState ? groupState?.content : '',
          userIds: preIds,
        });
        setLoading(false);
        // setContacts(
        //   res?.data?.response
        //     .filter((x) => x.typeId != 2)
        //     .map((v, i) => {
        //       return {
        //         ...v,
        //         checked:
        //           ids?.findIndex((x) => x == v?.users?.[0]?.channelUserId) == -1
        //             ? false
        //             : v?.users?.[0]?.statusId == 0
        //             ? false
        //             : true,
        //       };
        // })
        // );
      })
      .catch((err) => {});
  };
  // useEffect(() => {
  //   let preIds = contacts
  //     .filter((x) => x.statusId != 0)
  //     .map((i, j) => {
  //       return i?.channelUserId;
  //     });
  //   setGroupInfo({ ...groupInfo, userIds: preIds });
  // }, [contacts]);
  console.log('contact==', contacts);
  const handleCheckbox = (item, index) => {
    setShowErrorUsers(false);
    let newarray = [...contacts];
    newarray[newarray.findIndex((v) => v.id == item?.id)].checked =
      !newarray[newarray.findIndex((v) => v.id == item?.id)].checked;
    setContacts(newarray);
    let addedUsers = newarray.filter((x) => x.checked == true);
    let addedIds = [];
    addedIds = addedUsers.map((i, j) => {
      return i?.channelUserId;
    });
    setGroupInfo({ ...groupInfo, userIds: addedIds });
  };
  console.log('contacts', contacts);
  const sendFunction = () => {
    setServerError();
    let addedUsers = contacts.filter((x) => x.checked == true);
    let addedIds = [];
    addedIds = addedUsers.map((i, j) => {
      return i?.channelUserId;
    });
    if (checkError(addedIds)) {
    } else {
      if (groupState) {
        editFunction(groupState?.id, addedIds);
      } else {
        addFunction(addedIds);
      }
    }

    console.log('addedusers', addedUsers, addedIds);
  };
  // const updateUser = (info) => {
  //   ref.current.emit('private:userSingle', info, (data) => {
  //     console.log('nnnnnnnnnnnnnn', data);
  //   });
  // };

  const addFunction = (addedIds) => {
    Api.createGroup({
      imageId: groupInfo?.imageId,
      title: groupInfo?.title,
      content: groupInfo?.description,
      userIds: groupInfo?.userIds,
    })
      .then((res) => {
        setGroupState();
        setGroupInfo({
          imageId: '',
          title: '',
          description: '',
          userIds: [],
          imageName: '',
        });

        console.log('1');
        props?.updateUser({
          uuid: res.data?.response?.uuid,
          typeId: '2',
          // roomId: res?.data?.response?.id,
        });
        setOpenCreateGroup(false);
      })
      .catch((err) => {
        setServerError(err?.response?.data?.message);
      });
  };
  const editFunction = (id, addedIds) => {
    Api.editGroupInfo(id, {
      imageId: groupInfo?.imageId,
      title: groupInfo?.title,
      content: groupInfo?.description,
      // userIds: addedIds,
      userIds: groupInfo?.userIds,
    })
      .then((res) => {
        setGroupState();
        setGroupInfo({
          imageId: '',
          title: '',
          description: '',
          userIds: [],
          imageName: '',
        });

        props?.informLeftUser(res?.data?.response?.messageId);
        props?.updateUser({
          uuid: userChannelId,
          typeId: activeUser?.typeId,
          // roomId: activeUser?.id,
        });
        console.log('2');
        setOpenCreateGroup(false);
      })
      .catch((err) => {
        setServerError(err?.response?.data?.message);
      });
  };
  const uploadImage = () => {
    Api.uploadGroupImage()
      .then((res) => {})
      .catch((err) => {});
  };
  const submitFormFunction = () => {};
  const changeTitle = (e) => {
    setGroupInfo({ ...groupInfo, title: e.target?.value });
    setShowErrorTitle(false);
    setServerError();
  };
  const handleChange = (type, value) => {
    setGroupInfo({ ...groupInfo, description: value });
    setServerError();
  };
  const checkError = (addedIds) => {
    if (groupInfo?.title?.trim()?.length == 0 || addedIds?.length == 0) {
      if (groupInfo?.title?.trim()?.length == 0) {
        setShowErrorTitle(true);
      }
      if (addedIds?.length == 0) {
        setShowErrorUsers(true);
      }
      return true;
    } else {
      return false;
    }
  };
  console.log('groupInfo', groupInfo);
  return (
    <div
      className={` flex flex-col justify-start items-start w-full h-full relative ${
        styles.container
      } ${isMobile && styles.mobileStyle}`}
    >
      {/* <AppSearch
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        // autoFocus={true}
      /> */}
      <div className={`flex flex-row justify-start item-center w-full h-auto`}>
        <EditImage
          content={props?.content}
          groupInfo={groupInfo}
          setGroupInfo={setGroupInfo}
          setError={setServerError}
          className={styles.imageClassName}
        />
        <div className={`${styles.section} ${styles.sectionName}`}>
          <AppFormInput
            onChange={changeTitle}
            inputStyle={styles.inputStyle}
            showError={showErrorTitle}
            showTitle={showTitle}
            // onBlur={checkMobileNumber}
            // title={props?.content?.personalInfoModal?.groupname}
            error={props?.content?.errorRequired}
            placeholder={props?.content?.personalInfoModal?.groupname}
            // wrapperStyle={styles.wrapper}
            wrapperStyle={`${styles.wrapper} borderBottom`}
            value={groupInfo?.title}
          />
        </div>
      </div>

      <div className={styles.section}>
        <AppFormInput
          // title={props?.content?.personalInfoModal?.description}
          placeholder={props?.content?.personalInfoModal?.description}
          wrapperStyle={`${styles.wrapper} borderBottom`}
          // inputTitleClass={styles.class_title_email}
          // wraperClassName={styles.parent_input_text_area}
          inputStyle={
            errorContent ? styles.text_area_border_yellow : styles.text_area
          }
          showError={errorContent}
          error={props?.content?.errorRequired}
          onChange={(e) => {
            handleChange('content', e.target.value);
            setErrorContent(false);
          }}
          // rows="6"
          value={groupInfo?.description}
        />
      </div>
      <div
        className={`flex flex-col justify-start items-star w-full h-auto ${styles.introContainer}`}
      >
        <p className={styles.introTitle}>
          {groupState
            ? props?.content?.personalInfoModal?.introTitleEdit
            : props?.content?.personalInfoModal?.introTitleAdd}
        </p>
        <p className={styles.introText}>
          {groupState
            ? props?.content?.personalInfoModal?.introTextEdit
            : props?.content?.personalInfoModal?.introTextAdd}
        </p>
      </div>
      <div
        className={`flex flex-row justify-start items-start w-full h-auto flex-wrap ${styles.contactContainer} scrollDiv`}
      >
        {!loading ? (
          <>
            {contacts?.map((contact, index) => (
              <div
                key={index}
                className={`flex flex-row justify-between items-center w-full`}
              >
                <SingleContact contact={contact} showOnline={false} />
                <Checkbox
                  className="mb-[22px]"
                  checked={contact.checked}
                  onChange={() => handleCheckbox(contact, index)}
                />
              </div>
            ))}
          </>
        ) : (
          <Loader
            width={`w-full flex flex-row justify-center items-center mx-auto`}
          />
        )}
      </div>
      {showErrorUsers && (
        <p className={` inputError preserveWhiteThemeColor`}>
          {props?.content?.errorRequired}
        </p>
      )}
      {serverError?.length != 0 && (
        <p className={` inputError preserveWhiteThemeColor`}>{serverError}</p>
      )}
      <div
        className={`flex flex-row-reverse justify-start items-center w-full h-auto mt-auto`}
      >
        <Button
          onClick={sendFunction}
          className={`${styles.sendButton} ${
            isMobile && styles.marginBottom
          } mainBg`}
        >
          {/* {props?.content?.personalInfoModal?.submit} */}
          {groupState
            ? props?.content?.group?.editGroup
            : props?.content?.group?.createGroup}
        </Button>
      </div>
    </div>
  );
});

export default CraeteGroupModal;
